export default "__VITE_ASSET___app/immutable/assets/light-pointer-cursor.BbP9NCZ3.svg__"